import * as React from "react";

export default () => {
  return <div>Kostnader som upptstått under besiktningen</div>;
};
